import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { authService } from '@/services/AuthService'
import { linkAccountKeys } from '@/hooks/queryKeys'
import type { LinkAccountDto } from '@lib/dto/auth.dto'

/**
 * Whose account an invitation or password-reset link is for, so the page that
 * sets the password can show the address and a password manager can save the
 * password under it.
 *
 * Not retried and never refetched: the answer is fixed for as long as the link
 * lives, and a link that is dead stays dead. The page works without it; the
 * submit is what refuses a dead link.
 */
export function useLinkAccount(token: string): UseQueryResult<LinkAccountDto> {
  return useQuery({
    queryKey: linkAccountKeys.forToken(token),
    queryFn: () => authService.linkAccount({ token }),
    enabled: token !== '',
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  })
}
